let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lOt66")).then(() => parcelRequire('29Rfx'));